import React, { Component } from "react";
import './styles.scss';


const defaultAccountValues = [
  "https://www.facebook.com/yourname",
  "https://www.instagram.com/yourname"
];

class SocialIcon extends Component {
  state = {
    tooltipOpen: false
  };

  
  toggle = () => this.setState({ tooltipOpen: !this.state.tooltipOpen });

  render() {

    function buildImgUrl(socialName) {

        const baseURL = "https://myhellohello-bucket.s3.amazonaws.com/myhellohellostatic/myhellohellostatic/media/users/social_media_icons/";

        // Be sure to not include forward slash at beginning of stubs
        const socialStubs = {
            'Facebook': 'facebook-logo.png',
            'Instagram': 'instagram-logo.png',
            'Twitter': 'twitter-logo.png',
            'QQ': 'qq_logo.png',
            'Linkedin': 'linkedin-logo.png',
            'YouTube': 'youtube-logo.png',
            'Google+': 'google-plus-logo.png',
            'Vkontakte': 'vkontakte-logo.png',
            'Pinterest': 'pinterest-logo.png',
            'Reddit': 'reddit-logo.png',
            'Flickr': 'flickr-logo.png',
            'Skype': 'skype-logo.jpg',
            'Snapchat': 'snapchat-logo.png',
            'Sina Weibo': 'Sina_Weibo-logo.png'
        };
        // Break if no social name or social name is not in the list
        if (!socialName || !socialStubs.hasOwnProperty(socialName)) {
            return null;
        }
        let fileName = socialStubs[socialName];


        if (fileName) {
            const img_url = `${baseURL}${fileName}`;
            return img_url;
        } else {
            return null;
        }
    }
    const { socialName } = this.props;
    var img_url = null;
    if (socialName) {
        img_url = buildImgUrl(socialName);
    }

    return (
      <React.Fragment>
        {img_url ? (
            <div>
            <img src={img_url} className="social-img" />
          </div>

        ) : (
            <div />
        )}
      </React.Fragment>
    );
  }
}

export default SocialIcon;



// WEBPACK FOOTER //
// ./src/components/SocialLink/SocialIcon.jsx